import loadable from '@loadable/component';

// 懒加载组件
const HosItemQuery = loadable(() => import('./hosItemQuery/HosItemQuery'));
const HosItemPriceQuery = loadable(() => import('./hosItemPriceQuery/HosItemPriceQuery'));
const ItemPriceRequestManagement = loadable(() => import('./itemPriceRequestManagement/ItemPriceRequestManagement'));
const ItemPriceRequestDetailModify = loadable(() => import('./itemPriceRequestManagement/itemPriceRequestDetailModify/ItemPriceRequestDetailModify'));
const ItemNewApplicationWithSelection = loadable(() => import('./itemNewApplicationWithSelection/ItemNewApplicationWithSelection'));
const HosItemPriceWithUpstreamManagement = loadable(() => import('./hosItemPriceWithUpstreamManagement/HosItemPriceQuery.js'));
const HosItemPriceWithUpstreamQuery = loadable(() => import('./hosItemPriceWithUpstreamQuery/HosItemPriceWithUpstreamQuery'));
const ItemNewWithUpstreamApplication = loadable(() => import('./itemNewWithUpstreamApplication/ItemNewApplicationWithSelection'));
export const subRoutes = [
  {
    path: '/HosItemQuery',
    component: HosItemQuery
  },
  {
    path: '/HosItemPriceQuery',
    component: HosItemPriceQuery
  },
  {
    path: '/ItemPriceRequestManagement',
    component: ItemPriceRequestManagement
  },
  {
    path: '/ItemPriceRequestDetailModify',
    component: ItemPriceRequestDetailModify
  },
  {
    path: '/ItemNewApplicationWithSelection',
    component: ItemNewApplicationWithSelection
  },
  {
    path: '/HosItemPriceWithUpstreamManagement',
    component: HosItemPriceWithUpstreamManagement
  },
  {
    path: '/HosItemPriceWithUpstreamQuery',
    component: HosItemPriceWithUpstreamQuery
  },
  {
    path: '/ItemNewWithUpstreamApplication',
    component: ItemNewWithUpstreamApplication
  }
];
